import React from 'react';
import { BsXCircleFill } from 'react-icons/bs';

export default function ViewDetail({ modalStatus, setmodalStatus, getItem }) {
  return (
    <div>
      <div
        className={`fixed z-20 overflow-y-auto top-0 w-full left-0 ${
          modalStatus === true ? '' : 'hidden'
        }`}
        id="servicemodal"
      >
        <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity">
            <div className="absolute inset-0 bg-black opacity-75" />
          </div>
          <span className="flex h-screen justify-center items-center sm:inline-block sm:align-middle sm:h-screen">
            &#8203;
          </span>
          <div
            className="inline-block  align-center bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md  w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div className="bg-white sm:pb-4">
              {/* Body Start */}
              <div className="modal-body">
                <h4 className="text-base sm:text-base text-white text-center bg-gray-700 font-semibold tracking-wider py-3">
                  View Detail
                </h4>
                <div className="position-relative">
                  <BsXCircleFill
                    onClick={() => setmodalStatus(getItem)}
                    className="absolute text-white right-[17px] top-[19px] cursor-pointer text-lg"
                  />
                </div>
                <div className="text-black px-3 sm:px-5 py-2 sm:overflow-x-auto  scrollbar-thumb-gray-700 scrollbar-track-gray-100 scrollbar-thin  overflow-x-auto max-h-[20rem]">
                  <div className="flex flex-col max-h-60 scrollbar-thumb-gray-700 scrollbar-track-gray-100 scrollbar-thin  overflow-x-auto">
                    {getItem.length > 0 ? (
                      getItem.map((item, key) => {
                        return (
                          <div className="basis-full text-center py-1" key={key}>
                            {key + 1} . {item}
                          </div>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
              {/* Body End */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
